export const OptionGroup = ({ question, value, onChange }) => {
  const labelId = `q-${question.key}-label`;
  return (
    <fieldset data-testid={`apply-question-${question.key}`}>
      <legend id={labelId} className="mb-3 text-[15px] font-semibold leading-snug text-[#17130c]">{question.label}</legend>
      <div role="radiogroup" aria-labelledby={labelId} className="grid gap-2">
        {question.options.map(([slug, label]) => {
          const selected = value === slug;
          return (
            <button
              key={slug}
              type="button"
              role="radio"
              aria-checked={selected}
              onClick={() => onChange(slug)}
              className={`rounded-xl border px-4 py-3 text-left text-[15px] leading-snug transition-[background-color,color,border-color,transform] duration-200 active:scale-[0.99] ${selected ? "border-[#0a0a0a] bg-[#0a0a0a] font-semibold text-[#f3d27c] shadow-[0_6px_18px_-8px_rgba(0,0,0,0.6)]" : "border-[#d8c9a6] bg-[#fffdf8] text-[#2a2214] hover:border-[#b88a24]"}`}
              data-testid={`apply-option-${question.key}-${slug}`}
              data-selected={selected}
            >
              {label}
            </button>
          );
        })}
      </div>
    </fieldset>
  );
};
